/**
 * @file IconAdd Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-add',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.75}"
  >
    <path
      fill="#757575"
      fill-rule="nonzero"
      d="M24 0C37.25483 0 48 10.74517 48 24 48 37.25483 37.25483 48 24 48 10.74517 48 0 37.25483 0 24 0 10.74517 10.74517 0 24 0ZM24 3C12.40202 3 3 12.40202 3 24 3 35.59798 12.40202 45 24 45 35.59798 45 45 35.59798 45 24 45 12.40202 35.59798 3 24 3ZM24 11.7C24.73638 11.7 25.34883 12.23063 25.47583 12.93037L25.5 13.2 25.5 22.497 34.8 22.5C35.62843 22.5 36.3 23.17157 36.3 24 36.3 24.73638 35.76937 25.34883 35.06963 25.47583L34.8 25.5 25.5 25.497 25.5 34.8C25.5 35.62843 24.82843 36.3 24 36.3 23.26362 36.3 22.65117 35.76937 22.52417 35.06963L22.5 34.8 22.5 25.497 13.2 25.5C12.37157 25.5 11.7 24.82843 11.7 24 11.7 23.26362 12.23063 22.65117 12.93037 22.52417L13.2 22.5 22.5 22.497 22.5 13.2C22.5 12.37157 23.17157 11.7 24 11.7Z"
    />
  </g>
</svg>
`
);
